"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _function = require("../type-checks/function");
var _number = require("../type-checks/number");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var ClientTimer = /*#__PURE__*/function () {
  function ClientTimer() {
    var _this = this;
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      timerCountDownCallback = _ref.timerCountDownCallback,
      timerEndCallback = _ref.timerEndCallback;
    _classCallCheck(this, ClientTimer);
    _defineProperty(this, "_lastSyncDateTime", null);
    _defineProperty(this, "_secondsRemaining", -1);
    _defineProperty(this, "_timer", null);
    _defineProperty(this, "_timerCountDownCallback", null);
    _defineProperty(this, "_timerEndCallback", null);
    _defineProperty(this, "getClientCurrentDateTime", function () {
      return new Date().getTime();
    });
    _defineProperty(this, "getSecondsRemaining", function () {
      return _this._secondsRemaining;
    });
    try {
      if ((0, _function.isFunction)(timerCountDownCallback)) {
        this._timerCountDownCallback = timerCountDownCallback;
      } else {
        throw new TypeError("timerCountDownCallback is not a valid function");
      }
      if ((0, _function.isFunction)(timerEndCallback)) {
        this._timerEndCallback = timerEndCallback;
      } else {
        throw new TypeError("timerEndCallback is not a valid function");
      }
    } catch (e) {
      console.warn("Missing configuration for ClientTimer.constructor");
      console.warn(e);
    }
  }
  _createClass(ClientTimer, [{
    key: "_addSecondsToDateTime",
    value: function _addSecondsToDateTime(seconds, dateTime) {
      var targetDateTime = new Date(dateTime);
      return targetDateTime.setSeconds(targetDateTime.getSeconds() + seconds);
    }
  }, {
    key: "_countDown",
    value: function _countDown() {
      var _this2 = this;
      var isTimerStarting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this._secondsRemaining = this._secondsRemaining - 1;
      var clientCurrentDateTime = this.getClientCurrentDateTime();
      if (this._timer === null || isTimerStarting) {
        // Only perform these actions if the timer is being started;
        this._lastSyncDateTime = clientCurrentDateTime;
        this._lastSyncSecondsRemaining = this._secondsRemaining;
        this._anticipatedExpiryDateTime = this._addSecondsToDateTime(this._secondsRemaining, clientCurrentDateTime);
      }
      if (this._secondsRemaining > 0) {
        // Sync values as browser may deprioritize our script and seconds may be lost;
        var currentSyncDateTime = clientCurrentDateTime;
        var secondsSinceLastSync = this._getSecondsBetweenDateTimes(currentSyncDateTime, this._lastSyncDateTime);
        var syncDeltas = this._lastSyncSecondsRemaining - this._secondsRemaining;
        if (secondsSinceLastSync !== syncDeltas) {
          // Self-heal and synchronize seconds remaining with anticipated expiry;
          var syncSecondsRemaining = this._getSecondsBetweenDateTimes(clientCurrentDateTime, this._anticipatedExpiryDateTime);
          this._secondsRemaining = syncSecondsRemaining;
        }
        this._lastSyncDateTime = clientCurrentDateTime;
        this._lastSyncSecondsRemaining = this._secondsRemaining;
      }
      if (clientCurrentDateTime < this._anticipatedExpiryDateTime && this._secondsRemaining >= 0) {
        this._timer = setTimeout(function () {
          (0, _function.isFunction)(_this2._timerCountDownCallback) && _this2._timerCountDownCallback(_this2._secondsRemaining);
          _this2._countDown();
        }, 1000);
      } else {
        (0, _function.isFunction)(this._timerEndCallback) && this._timerEndCallback();
        this.resetTimer();
      }
    }
  }, {
    key: "_getSecondsBetweenDateTimes",
    value: function _getSecondsBetweenDateTimes(dateTimeA, dateTimeB) {
      return Math.abs(Math.floor((dateTimeA - dateTimeB) / 1000));
    }
  }, {
    key: "resetTimer",
    value: function resetTimer() {
      clearTimeout(this._timer);
      this._timer = null;
      this._secondsRemaining = -1;
      this._lastSyncDateTime = null;
      this._lastSyncSecondsRemaining = null;
      this._anticipatedExpiryDateTime = null;
    }
  }, {
    key: "startTimer",
    value: function startTimer(targetSecondsRemaining) {
      if ((0, _number.isNumber)(targetSecondsRemaining) && targetSecondsRemaining > 0) {
        this.resetTimer();
        this._secondsRemaining = targetSecondsRemaining;
        this._countDown(true);
      }
    }
  }]);
  return ClientTimer;
}(); // Export component as default;
var _default = exports.default = ClientTimer;